import { sessionManager } from './sessionManager';
import { sessionStorageService } from './sessionStorageService';
import { vippsStateManager } from './vippsStateManager';

// Cleanup all expired session data at app start
// This prevents accumulation of stale data and ensures fresh sessions
function cleanupExpiredSessionData() {
    try {
        // Cleanup is handled automatically by TTL validation in get methods
        // But we can proactively trigger cleanup by attempting to read each value
        // The get methods will remove expired data automatically
        
        // sessionManager: TTL validation happens in getSession(), getToken(), getUser()
        // Just accessing them will trigger cleanup if expired
        sessionManager.getSession(); // Validates 24h TTL
        sessionManager.getToken(); // Validates 2h TTL
        sessionManager.getUser(); // Validates 2h TTL
        
        // sessionStorageService: TTL validation happens in get methods
        sessionStorageService.getDeviceUuid(); // Validates 2h TTL
        sessionStorageService.getRedirectTime(); // Validates 5min TTL
        sessionStorageService.getRedirectBrowser(); // Validates 5min TTL
        
        // vippsStateManager: TTL validation happens in getAuthToken()
        vippsStateManager.getAuthToken(); // Validates 10min TTL
        
        // Also cleanup stale Vipps state/code data (already has 10min stale cleanup)
        // This is handled by vippsStateManager's existing cleanup logic
        
        console.debug('Expired session data cleanup completed');
    } catch (error) {
        console.warn('Error during expired session data cleanup (non-blocking):', error);
    }
}

export const initializeSession = async () => {
    try {
        // First, cleanup any expired session data
        cleanupExpiredSessionData();
        
        const token = sessionManager.getToken();
        const user = sessionManager.getUser();

        if (!token || !user) {
            sessionManager.clearSession();
            // Ensure a session id exists for request tagging even without auth
            sessionManager.getSession();
            return false;
        }

        // Ensure a session id is present regardless
        sessionManager.getSession();
        return true;
    } catch (error) {
        console.error('Error initializing session:', error);
        sessionManager.clearSession();
        sessionManager.getSession();
        return false;
    }
};

// Backwards-compat named export used in some modules
export const initializeAppSession = initializeSession;


